(function () {
  const btn = document.getElementById('pause-animations-toggle');
  const body = document.body;
  const STORAGE_KEY = 'animationsPaused';

  const videos = Array.from(document.querySelectorAll('video'));
  const slideshows = Array.from(document.querySelectorAll('slideshow-component'));
  const layout = document.getElementById('custom-media-layout');


  function pauseCSS() {
    body.classList.add('animations-paused');
  }

  function resumeCSS() {
    body.classList.remove('animations-paused');
  }

  function pauseVideos() {
    videos.forEach(video => {
      if (!video.paused) video.pause();
    });
  }

  function resumeVideos() {
    videos.forEach(video => {
      if (video.paused && video.readyState >= 2) {
        video.muted = true;
        video.play().catch(() => {});
      }
    });
  }

  function stopDawnSlideshow() {
    slideshows.forEach(component => {
      const slider = component.querySelector('.slideshow');
      if (!slider) return;

      if (slider.dataset.autoplay === "false") return; // već ugašen

      slider.dataset.autoplay = "false";

      const btn = component.querySelector('.slideshow__autoplay');
      if (btn && !btn.classList.contains('slideshow__autoplay--paused')) {
        btn.click();
      }

      if (component.slider?.autoplay) {
        component.slider.autoplay.stop();
      }
    });
  }

  function startDawnSlideshow() {
    slideshows.forEach(component => {
      const slider = component.querySelector('.slideshow');
      if (!slider) return;

      if (slider.dataset.autoplay === "true") return;

      slider.dataset.autoplay = "true";

      const btn = component.querySelector('.slideshow__autoplay');
      if (btn && btn.classList.contains('slideshow__autoplay--paused')) {
        btn.click();
      }

      if (component.slider?.autoplay) {
        component.slider.autoplay.start();
      }
    });
  }

  function updateState(paused) {
    if (btn) {
      btn.setAttribute('aria-pressed', paused);
      btn.classList.toggle('is-paused', paused);
      btn.querySelector('.pause-text').textContent = paused ? 'RESUME MOTION' : 'PAUSE MOTION';
    }
    localStorage.setItem(STORAGE_KEY, paused);
  }


  function pauseAll() {
    pauseCSS();
    pauseVideos();
    stopDawnSlideshow();

    if (layout) {
      layout.classList.add('gallery-video-paused');
    }

    updateState(true);
  }

  function resumeAll() {
    resumeCSS();
    resumeVideos();
    startDawnSlideshow();

    if (layout) {
      layout.classList.add('gallery-video-paused');
    }

    updateState(false);
  }

  if (btn) {
    btn.addEventListener('click', () => {
      const paused = body.classList.contains('animations-paused');
      paused ? resumeAll() : pauseAll();
    });
  }

  window.addEventListener('load', () => {
    if (localStorage.getItem(STORAGE_KEY) === 'true') {
      pauseAll();
    }
  });
})();
